module.exports = "/_next/static/images/PersonalizeOnEveryChannelMobile@2x-42763de7c65f252c3169d17874d6c75d.webp";